import { camelCaseObjectToSnakeCase } from '../../utils/convert-case';
import {
  serviceNameValues,
  fieldNames,
  OTHER_VALUE,
  packageValuesToPriceValues,
  doesHasContentValues,
} from '../constants/common';

const prepareDifmData = (values) => {
  let data;

  switch (values[fieldNames.SERVICE_NAME]) {
    case serviceNameValues.BUILD_YOUR_DREAM_SITE: {
      const { contentType, otherContentType, doesHasContent, ...restValues } = values;

      data = {
        ...restValues,
        [fieldNames.CONTENT_TYPE]: contentType.length
          ? contentType.join().replace(OTHER_VALUE, otherContentType)
          : null,
        [fieldNames.DOES_HAS_CONTENT]: Boolean(doesHasContent === doesHasContentValues.YES),
      };
      break;
    }
    case serviceNameValues.REVAMP_YOUR_WEBSITE: {
      data = values;
      break;
    }
    case serviceNameValues.MIGRATE_YOUR_SITE_TO_YOLA: {
      const {
        oldWebsitePlatform,
        otherOldWebsitePlatform,
        migrationReason,
        otherMigrationReason,
        ...restValues
      } = values;
      data = {
        ...restValues,
        [fieldNames.OLD_WEBSITE_PLATFORM]: oldWebsitePlatform.replace(
          OTHER_VALUE,
          otherOldWebsitePlatform
        ),
        [fieldNames.MIGRATION_REASON]: migrationReason
          .join()
          .replace(OTHER_VALUE, otherMigrationReason),
      };
      break;
    }
    default: {
      data = {};
    }
  }

  data[fieldNames.PRICE] = packageValuesToPriceValues[data[fieldNames.SELECTED_PACKAGE]];

  return camelCaseObjectToSnakeCase(data);
};

export default prepareDifmData;
